import classNames from 'classnames';
import {DetailedHTMLProps, FC, FieldsetHTMLAttributes, ReactNode} from 'react';
import styles from './MeinFieldset.module.css';

interface IProps extends DetailedHTMLProps<
    FieldsetHTMLAttributes<HTMLFieldSetElement>,
    HTMLFieldSetElement
> {
    legend?: ReactNode;
}

export const MeinFieldset: FC<IProps> = ({legend, className, children}) => {
    return (
        <fieldset className={classNames(styles.fieldset, className)}>
            {legend && <legend className={styles.legend}>{legend}</legend>}
            {children}
        </fieldset>
    );
};
